"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConsentCookie = exports.getConsentCookie = exports.COOKIE_EXPIRATION = exports.COOKIE_NAME = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var getCookieConsentDomain_1 = require("./getCookieConsentDomain");
exports.COOKIE_NAME = 'consent';
exports.COOKIE_EXPIRATION = 365; // in days
function getConsentCookie() {
    var value = js_cookie_1.default.get(exports.COOKIE_NAME);
    if (value === undefined) {
        return null;
    }
    try {
        return Boolean(JSON.parse(value));
    }
    catch (error) {
        return null;
    }
}
exports.getConsentCookie = getConsentCookie;
function setConsentCookie(value) {
    var domain = (0, getCookieConsentDomain_1.getCookieConsentDomain)();
    // remove cookie added on the default host (for migration)
    js_cookie_1.default.remove(exports.COOKIE_NAME);
    // remove cookie added on the specified host
    js_cookie_1.default.remove(exports.COOKIE_NAME, { domain: domain });
    // write cookie on the specified host
    js_cookie_1.default.set(exports.COOKIE_NAME, JSON.stringify(value), {
        expires: exports.COOKIE_EXPIRATION,
        domain: domain,
    });
}
exports.setConsentCookie = setConsentCookie;
//# sourceMappingURL=cookieState.js.map